import {
  provideAppInitializer,
  inject,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { EnvService } from './app/services/env.service';
import { TranslateService, provideTranslateService } from '@ngx-translate/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { formReducer } from './app/state/form.reducers';
import { EffectsModule } from '@ngrx/effects';
import { QrEditEffects } from './app/state/qr-edit.effects';
import { SubmitEffects } from './app/state/submit.effects';
import { AppComponent } from './app/app.component';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LaunchParamsService } from './app/services/launch-params.service';

function appInit(env: EnvService, translate: TranslateService, launchParams: LaunchParamsService) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (): Promise<any> =>
    env
      .loadExternalConfig()
      .catch(() => console.log(translate.instant('Config.Build')))
      .then(() => {
        let overrides;
        try {
          overrides = launchParams.resolveOverrides();
        } catch (err) {
          env.configError = err as Error;
          return;
        }
        env.applyLaunchOverrides(overrides);
      });
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      StoreModule.forRoot({ form: formReducer }),
      EffectsModule.forRoot([QrEditEffects, SubmitEffects]),
    ),
    provideTranslateService({ fallbackLang: 'en' }),
    provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    provideAppInitializer(() => {
      const initializerFn = appInit(
        inject(EnvService),
        inject(TranslateService),
        inject(LaunchParamsService),
      );
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
